import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { JobTypeActions } from '../actions/job-type.actions';
import { JobType } from '../models/job-type.model';
import { JobTypeService } from 'src/app/services/job-type.service';
import { StorageService } from 'src/app/services/storage.service';

export class JobTypeStateModel {
    is_refreshing: boolean
    job_type: JobType[]
}

@State<JobTypeStateModel>({
    name: 'job_type',
    defaults: {
        is_refreshing: true,
        job_type: []
    }
})
@Injectable()
export class JobTypeState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private job_typeService: JobTypeService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<JobTypeStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                      
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {             
        if (this.storageService.is_initialized) {
            const state_model: JobTypeStateModel = change.currentValue      
            this.storageService.set('job_types', JSON.stringify(state_model))    
        }  
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('job_types');        
        if (json) {
            const state_model: JobTypeStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new JobTypeActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new JobTypeActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.job_typeService.getAll()    
        if (objs != null) {
          const many = JobType.buildMany(objs)                  
          this.store.dispatch(new JobTypeActions.Set(many))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: JobTypeStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: JobTypeStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: JobTypeStateModel) {
        return state.job_type
    }

    @Action(JobTypeActions.Refresh)
    async refresh({patchState}: StateContext<JobTypeStateModel>, {  }:JobTypeActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(JobTypeActions.Init)
    init({setState, getState}: StateContext<JobTypeStateModel>, { payload }:JobTypeActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new JobTypeActions.Refresh())
    }
    
    @Action(JobTypeActions.Set)
    set({setState}: StateContext<JobTypeStateModel>, { payload }:JobTypeActions.Set) {             
        setState({   
            is_refreshing: false,         
            job_type: payload
        })
    }
}
